import { McComponent } from "./gxc.js";




export class McAppNav extends McComponent {
  /**
   * @type {HTMLDivElement}
  **/
  app_container;

  constructor() {
    super()
    this.attachShadow(({ mode: 'open' }))
    this.shadowRoot.innerHTML = `
<link rel="stylesheet" href="mache.css"/>
<style>
  :host {
    width: 100vw;
    <!-- background-color: red; -->
    border: 1px solid red;
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
    align-items: center;
    z-index: 50;
  }

  :host([vertical]) {
  }

  :host([horizontal])  {
  }


  .app-container {
    width: 100%;
    padding: 0 .5rem;
    background-color: hsl(var(--mc-surface));
    gap: .5rem;
    border-bottom: 1px solid hsl(var(--mc-subtle)/.3);
  }
</style>

<div class="app-container mc-card mc-gap1rem">
  <slot><slot>
</div>
`
    this.app_container = this.shadowRoot.querySelector('.app-container')
  }


  static get observedAttributes() {
    return ["horizontal", "vertical", "top", "bottom", "left", "right", "float", "gap"]
  }


  connectedCallback() {
  }


  attributeChangedCallback(name, oldv, newv) {
    this.onAttribute(name, newv)
  }


  onAttribute(attr, val) {
    switch (attr) {
      case "horizontal":
        this.app_container.classList.remove("mc-flex", "mc-column")
        this.app_container.classList.add("mc-flex", "mc-row", "mc-acenter")
        this.app_container.style.width = "100%"
        this.shadowRoot.host.style.width = "100vw"
        break
      case "vertical":
        this.app_container.classList.remove("mc-flex", "mc-row")
        this.app_container.classList.add("mc-flex", "mc-column")
        this.app_container.style.width = "max-content"
        this.app_container.style.height = "100vh"
        this.shadowRoot.host.style.width = "max-content"
        break
      case "top":
        this.shadowRoot.host.style.top = "0"
        break
      case "bottom":
        this.shadowRoot.host.style.bottom = "0"
        break
      case "left":
        this.shadowRoot.host.style.left = "0"
        break
      case "right":
        this.shadowRoot.host.style.right = "0"
        break
      case "float":
        this.app_container.classList.add("mc-rcorners")
        this.app_container.style.boxShadow = "0 0 .3rem rgba(0,0,0,.3)"

        this.shadowRoot.host.style.left = "50%"
        this.shadowRoot.host.style.width = "95vw"
        this.shadowRoot.host.style.padding = ".5rem"
        this.shadowRoot.host.style.transform = "translateX(-50%)"
        // this.shadowRoot.host.style.marginRight = "auto"
        break;
      case "gap":
        this.app_container.style.gap = val;
    }
  }


  remove_float() {

  }


}


if (!window.customElements.get("mc-appnav")) {
  window.customElements.define(("mc-appnav"), McAppNav)
}
